import { useBackgroundJobNotifications } from "../hooks/useBackgroundJobNotifications";

/** Mount once inside WebSocketProvider — shows toasts for background jobs. */
export default function BackgroundJobListener() {
  useBackgroundJobNotifications();
  return null;
}
